export default "__VITE_ASSET__8889967a__"